import { action, computed, makeObservable, observable } from 'mobx';
import { Payment as PaymentModel } from '@data/models';
import { PAYMENT_METHOD } from '@data/models/Payment';
import CreditCard from '@data/models/CreditCard';

export default class Payment {
  @observable model: PaymentModel = new PaymentModel();

  constructor() {
    makeObservable(this);
  }

  @action.bound setMethod = (method: PAYMENT_METHOD) => {
    this.model.method = method;
  };

  @action.bound setCreditCard = (card: CreditCard) => {
    this.model.card = card;
  };

  @computed get creditCard() {
    return this.model.card;
  }
}
